// import { useAuthStore } from '../../store/authStore';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line, PieChart, Pie, Cell } from 'recharts';
import { getData } from '../../services/FetchNodeServices';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {

  const [user, setUser] = useState(() => {
    const storedUser = sessionStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [amcs, setAmcs] = useState(0);
  const [salesData, setSalesData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [recentActivities, setRecentActivities] = useState([]);
  const [totaleActiveAcount, setTotaleActiveAcount] = useState(0);
  const [totalExpiringThisMonth, setTotalExpiringThisMonth] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [totalDistributors, setTotalDistributors] = useState(0);
  const [totalRetailers, setTotalRetailers] = useState(0);
  const [totalDistributorWalletAmount, setTotalDistributorWalletAmount] = useState(0);
  const [totalRetailerWalletAmount, setTotalRetailerWalletAmount] = useState(0);

  const navigate = useNavigate();

  const
    StatCard = ({ title, value, icon, color, change, path }) => (
      <div className="bg-white rounded-lg shadow p-6  " >
        <div className="flex items-center justify-between cursor-pointer" onClick={() => navigate(path)}>
          <div>
            <p className="text-sm font-medium text-gray-600  ">{title}</p>
            <p className="text-2xl font-bold text-gray-900 mt-1">{value}</p>
            {change && (
              <p className="text-sm text-green-600 mt-1">
                <i className="ri-arrow-up-line w-4 h-4 inline-flex items-center justify-center"></i>
                {change}
              </p>
            )}
          </div>
          <div className={`w-12 h-12 ${color} rounded-lg flex items-center justify-center`}>
            <i className={`${icon} text-white text-xl w-6 h-6 flex items-center justify-center`}></i>
          </div>
        </div>
      </div>
    );
  ///////////////////////////////////////////////////////////////////////////////
  const fetchAmc = async () => {
    try {
      if (!user?.id) return;

      const queryJson = new URLSearchParams({
        userId: user?.id?.toString() || "",
        role: user?.role?.toString() || "",
        createdByEmail: JSON.stringify({
          email: user?.role === "distributor" || user?.role === "retailer" || user?.role === "promoter"
            ? user?.email?.toString() || ""
            : "Tanyasharma5535.ts@gmail.com",
          name: user?.role === "distributor" || user?.role === "retailer" || user?.role === "promoter"
            ? user?.name?.toString() || ""
            : "Admin"
        })

      });

      const response = await getData(`api/dashboard/get-all-amc-total?${queryJson}`);
      console.log("response ===>", response);
      setAmcs(response?.data.totalAmc || 0);
      setTotaleActiveAcount(response?.data?.totalActiveAccount || 0);
      setTotalExpiringThisMonth(response?.data?.totalExpiringThisMonth || 0);
      setTotalDistributors(response?.data?.totalDistributors || 0);
      setTotalRetailers(response?.data?.totalRetailers || 0);
      setTotalRevenue(response?.data?.totalRevenue || 0);
      setSalesData(response?.data?.amcSalesData || []);
      setProductData(response?.data?.amcProductData || []);
      setRecentActivities(response?.data?.amcRecentActivities || []);
      setTotalDistributorWalletAmount(response?.data?.totalDistributorWalletAmounts || 0);
      setTotalRetailerWalletAmount(response?.data?.totalRetailerWalletAmounts || 0);

    } catch (error) {
      console.error("Error fetching AMC:", error);
    }
  };

  useEffect(() => {
    fetchAmc()
  }, [])
  ///////////////////////////////////////////////////////////////////////////////

  const formatAmount = (amount) => {
    if (amount >= 100000) return `${(amount / 100000).toFixed(2)}L`;
    if (amount >= 1000) return `${(amount / 1000).toFixed(2)}k`;
    return amount.toString();
  };

  console.log("salesData ===>VVV", salesData)
  return (
    <div className="p-2 sm:p-4 md:p-5 lg:p-6 space-y-3 sm:space-y-4 md:space-y-6 max-w-full overflow-hidden">

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-0">
        <h1 className="text-sm sm:text-base md:text-lg font-bold text-gray-900">
          Dashboard
        </h1>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 lg:gap-6">

        <StatCard
          title="Total WECs"
          value={amcs.toLocaleString()}
          icon="ri-file-shield-line"
          color="bg-blue-500"
          path="/amcs"
        />

        <StatCard
          title="Active Contracts"
          value={totaleActiveAcount.toLocaleString()}
          icon="ri-checkbox-circle-line"
          color="bg-green-500"
          path="/amcs"
        />

        <StatCard
          title="Expiring This Month"
          value={totalExpiringThisMonth.toLocaleString()}
          icon="ri-alarm-warning-line"
          color="bg-yellow-500"
        />

        <StatCard
          title="Total Revenue"
          value={`₹${Math.round(totalRevenue).toLocaleString()}`}
          icon="ri-money-dollar-circle-line"
          color="bg-purple-500"
        />
      </div>

      {/* Distributor / Retailer Cards */}
      {user?.role !== 'retailer' && user?.role !== 'distributor' && user?.role !== 'promoter' && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-5">
          <StatCard title="Total Distributors" value={totalDistributors} icon="ri-building-line" color="bg-indigo-500" path="/users" />

          <StatCard title="Distributors Wallets" value={`₹${Math.round(totalDistributorWalletAmount).toLocaleString()}`} icon="ri-wallet-fill" color="bg-indigo-500" path="/users" />

          <StatCard title="Total Retailers" value={totalRetailers} icon="ri-store-line" color="bg-pink-500" path="/users" />

          <StatCard title="Retailers Wallets" value={`₹${Math.round(totalRetailerWalletAmount).toLocaleString()}`} icon="ri-wallet-fill" color="bg-pink-500" path="/wallet" />
        </div>
      )}

      {/* Charts */}
      {salesData && salesData.length > 0 && (
        <div className="bg-white rounded-lg shadow p-4 md:p-6">
          <h3 className="text-sm md:text-lg font-semibold text-gray-900 mb-4">
            WEC Sales Trend
          </h3>
          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={salesData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="sales" stroke="#3B82F6" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}

      {/* Product Distribution */}
      {productData && productData.length > 0 && (
        <div className="bg-white rounded-lg shadow p-4 md:p-4">
          <h3 className="text-sm md:text-lg font-semibold text-gray-900 mb-4">
            WEC Distribution by Product Category
          </h3>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-4">
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  data={productData}
                  cx="50%"
                  cy="50%"
                  outerRadius={90}
                  dataKey="value"
                  label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                >
                  {productData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>

            <div className="space-y-3 md:space-y-4">
              {productData.map((item, index) => (
                <div key={index} className="flex items-center justify-between p-2 md:p-3 bg-gray-50 rounded-lg">
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 rounded-full" style={{ backgroundColor: item.color }}></div>
                    <span className="text-sm md:text-base font-medium text-gray-900">{item.name}</span>
                  </div>
                  <span className="text-xs md:text-sm text-gray-600">{item.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Recent Activity */}
      {recentActivities && recentActivities.length > 0 && (
        <div className="bg-white rounded-lg shadow p-4 md:p-6">
          <h3 className="text-sm md:text-lg font-semibold text-gray-900 mb-4">
            Recent Activity
          </h3>

          <div className="space-y-3">
            {recentActivities.map((activity, index) => (
              <div key={index} className="flex items-center space-x-3 md:space-x-4 p-2 md:p-3 hover:bg-gray-50 rounded-lg">
                <div className="w-8 h-8 md:w-10 md:h-10 bg-gray-100 rounded-full flex items-center justify-center">
                  <i className={`${activity.icon} ${activity.color} w-4 h-4 md:w-5 md:h-5`}></i>
                </div>
                <div className="flex-1">
                  <p className="text-sm md:text-xs font-medium text-gray-900">{activity.action}</p>
                  <p className="text-[9px] md:text-xs text-gray-500">{activity.user} • {activity.time}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>

  );
}